import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: { title: '首页' },
            children:[
                {
                    path: '/home',
                    component: resolve => require(['../components/page/Dashboard.vue'], resolve),
                    meta: { title: '系统首页' }
				},
                {
                    path: '/sysrole',
                    component: resolve => require(['../components/page/RoleManage.vue'], resolve),
                    meta: { title: '角色管理' }
                },
                {
                    path: '/sysuser',
                    component: resolve => require(['../components/page/UserManage.vue'], resolve),
                    meta: { title: '用户管理' }
                },
                {
                    path: '/syslog',
                    component: resolve => require(['../components/page/LogManage.vue'], resolve),
                    meta: { title: '系统日志' }
                },
                {
                    path: '/emprehandle',
                    component: resolve => require(['../components/page/EmpReHandle.vue'], resolve),
                    meta: { title: '待办人员' }
                },
                {
                    path: '/vehrehandle',
                    component: resolve => require(['../components/page/VehReHandle.vue'], resolve),
                    meta: { title: '待办车辆' }
                },
                {
                    path: '/cardbus',
                    component: resolve => require(['../components/page/CardBusiness.vue'], resolve),
                    meta: { title: '卡片业务' }
                },
                {
                    path: '/vehbus',
                    component: resolve => require(['../components/page/VehBusiness.vue'], resolve),
                    meta: { title: '车辆业务' }
                },
                {
                    path: '/tempbus',
                    component: resolve => require(['../components/page/TempBusiness.vue'], resolve),
                    meta: { title: '车辆业务' }
                },
                {
                    path: '/applyrecord',
                    component: resolve => require(['../components/page/ApplyRecordReport.vue'], resolve),
                    meta: { title: '申请记录报表' }
                },
                {
                    path: '/eventrecord',
                    component: resolve => require(['../components/page/EventRecord.vue'], resolve),
                    meta: { title: '门禁事件报表' }
                },
                {
                    path: '/tempexrecord',
                    component: resolve => require(['../components/page/TemperatureExceptionReport.vue'], resolve),
                    meta: { title: '测温异常报表' }
                },
				{
					path: '/devicemanager',
					component: resolve => require(['../components/page/DeviceManager.vue'], resolve),
					meta: { title: '设备管理' }
				},
                {
                    path: '/premeal',
                    component: resolve => require(['../components/page/PreMealReport.vue'], resolve),
                    meta: { title: '中晚餐备餐表' }
                },
                {
                    path: '/sendmeal1',
                    component: resolve => require(['../components/page/SendMeal1Report.vue'], resolve),
                    meta: { title: '中晚餐送餐表' }
                },
                {
                    path: '/sendmeal2',
                    component: resolve => require(['../components/page/SendMeal2Report.vue'], resolve),
                    meta: { title: '其他送餐表' }
                },
                {
                    path: '/balanceBooks',
                    component: resolve => require(['../components/page/BalanceBooksRecord.vue'], resolve),
                    meta: { title: '消费结算表' }
                },
                {
                    path: '/yhpremeal',
                    component: resolve => require(['../components/page/YHPreMealReport.vue'], resolve),
                    meta: { title: '中晚餐备餐表' }
                },
                {
                    path: '/yhsendmeal1',
                    component: resolve => require(['../components/page/YHSendMeal1Report.vue'], resolve),
                    meta: { title: '中晚餐送餐表' }
                },
                {
                    path: '/yhsendmeal2',
                    component: resolve => require(['../components/page/YHSendMeal2Report.vue'], resolve),
                    meta: { title: '其他送餐表' }
                },
                {
                    path: '/yhbalancebooks',
                    component: resolve => require(['../components/page/YHBalanceBooksRecord.vue'], resolve),
                    meta: { title: '消费结算表' }
                },
                {
                    path: '/foodtotal',
                    component: resolve => require(['../components/page/FoodTotalReport.vue'], resolve),
                    meta: { title: '菜品统计表' }
                },
                {
                    path: '/dailysalestotal',
                    component: resolve => require(['../components/page/DailySalesTotalReport.vue'], resolve),
                    meta: { title: '日营业额统计表' }
                },
                {
                    path: '/dailybooktotal',
                    component: resolve => require(['../components/page/DailyBookTotalReport.vue'], resolve),
                    meta: { title: '每日订餐汇总' }
                },
                {
                    path: '/balancesetting',
                    component: resolve => require(['../components/page/YHBalanceSetting.vue'], resolve),
                    meta: { title: '消费结算设置' }
                },
                {
                    path: '/icon',
                    component: resolve => require(['../components/page/Icon.vue'], resolve),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/404',
                    component: resolve => require(['../components/page/404.vue'], resolve),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: resolve => require(['../components/page/403.vue'], resolve),
                    meta: { title: '403' }
                },
                {
                    path: '/camera',
                    component: resolve => require(['../components/page/camera.vue'], resolve),
                    meta: { title: 'camera' }
                },
                {
                    path: '/changepwd',
                    component: resolve => require(['../components/page/ChangePwd.vue'], resolve),
                    meta: { title: '修改密码' }
                }
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/Login.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})
